module.exports = __webpack_public_path__ + "static/media/Jaelin.f0073185.jpeg";